import ModalHeader from "../../Setup/Shared/ModalHeader"
import { Modal } from "react-bootstrap";
import { SelectColumn } from "react-data-grid"
import DataGrid from 'react-data-grid';
import { enumUtil } from "../../../utils/Enum";
import { useEffect, useState } from "react";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import Loader from "../Loader/Loader";
const ProcedureSearch = (props) => {
  const { isOpenCPT, onCloseCPT, handleSelecCPT, onRowSelection, rowKeyGetter, rowKeyGetterMacro, selectedRows, options } = { ...props }
  const [searchParam, setSearchParam] = useState(null)
  const API_URL = enumUtil.controller.Claim
  const [isLoading, setIsLoading] = useState(false)
  const [recCPT, setRecCPT] = useState([])
  const [recProMacro, setRecProMacro] = useState([])
  const [active, setActive] = useState(false)
  const [searchMethod, setSearchMethod] = useState("CPT")


  const [recOpened, setRecOpened] = useState(false)
  const [PerPage, setPerPage] = useState("10")
  const [PageNo, setPerPageNo] = useState("1")
  const [TotalPages, setTotalPages] = useState();
  const handlePageClick = (page) => { setPerPageNo(page); }
  const PreviousPage = () => { if (PageNo > 1) setPerPageNo(PageNo - 1); }
  const NextPage = () => { if (PageNo < TotalPages) setPerPageNo(PageNo + 1); }
  const dgheading = () => {
    return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px', fontWeight: '600', }}>Procedure Code</p>;
  };
  const handleFingByCreteria = (e) => {
    setPerPage(e.target.value)
    setPerPageNo(1)
  }
  const columnsAll = [
    {
      ...SelectColumn,
    },
    {
      key: 'ProcedureCode',
      name: (
        <div className="column-container">
          <span>Procedure Code</span>
          <i className="icon-arrows-gray" />
        </div>
      ),
      width: 150,
    },
    {
      key: 'Description',
      name: (
        <div className="column-container">
          <span>Description</span>
          {/* <i className="icon-arrows-gray" /> */}

        </div>
      ),
      width: 292,
      renderCell: ({ row }) => {
        return (
          <div className="validation_message" title={row.Description}>{row.Description}</div>
        );
      },
    },

    {
      key: 'Amount',
      name: 'Amount',
      width: 140,
      cellClass: 'last-column',
      headerCellClass: 'last-column',
    },
  ]
  const columnsAllMacro = [
    {
      ...SelectColumn,
    },
    {
      key: 'Name',
      name: (
        <div className="column-container">
          <span>Name</span>
          <i className="icon-arrows-gray" />
        </div>
      ),
      width: 80,
    },
    {
      key: 'Type',
      name: (
        <div className="column-container">
          <span>Type</span>
          <i className="icon-arrows-gray" />
        </div>
      ),
      flex: 1,
    },
    {
      key: 'Description',
      name: (
        <div className="column-container">
          <span>Description</span>
          <i className="icon-arrows-gray" />
        </div>
      ),
      flex: 1,
    },
    {
      key: 'Amount',
      name: 'Amount',
      width: 80,
    },
  ]
  const LoadData = (searchParam) => {
    setRecOpened(false)
    setIsLoading(true);
    let SEARCHCRITERIA = {
      "Search": searchParam,
      "SearchType": "All",
      "SearchMethod": searchMethod,
    }
    ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
      "TableName": enumUtil.enumAPITableName.Procedure,
      "SEARCHCRITERIA": SEARCHCRITERIA,
      "value": active === true ? '1' : '0',
      'PERPAGE': PerPage,
      'PAGENO': PageNo
    })
      .then((response) => {
        if (searchMethod === 'CPT') {
          setRecCPT(response.Rows)
        } else {
          setRecProMacro(response.ProcedureMacro)
        }
        setTotalPages(response.count.NumOfPages);


        setIsLoading(false);
      }).catch((error) => {
        setRecCPT([])
        setIsLoading(false);
      })
  }
  const SearchOnEnter = (e) => {
    if (e.key === "Enter") {
      setSearchParam(e.target.value)
      LoadData(e.target.value)
    }
  }
  const onSelectCPT = () => {
    if (searchMethod === 'CPT') {
      handleSelecCPT(recCPT, 'CPT')
    } else {
      handleSelecCPT(recProMacro, 'ProcedureMacro')
    }
  }
  useEffect(() => {
    setRecOpened(true)
    setIsLoading(true);
    let SEARCHCRITERIA = {
      "Search": searchParam,
      "SearchType": "Recent",
      "SearchMethod": searchMethod,
    }
    ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
      "TableName": enumUtil.enumAPITableName.Procedure,
      "SEARCHCRITERIA": SEARCHCRITERIA,
      "value": active === true ? '1' : '0',
      'PERPAGE': PerPage,
      'PAGENO': PageNo
    })
      .then((response) => {
        if (searchMethod === 'CPT') {
          setRecCPT(response.Rows)
        } else {
          setRecProMacro(response.ProcedureMacro)
        }
        setTotalPages(response.count.NumOfPages);
        setIsLoading(false);
      }).catch((error) => {
        setRecCPT([])
        setIsLoading(false);
      })
  }, [])
  const handleOnChange = (e) => {
    const { value } = e.target;
    setSearchMethod(value);
  }
  return (
    <Modal show={isOpenCPT} onHide={onCloseCPT} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal ar_palceholder">
      {isLoading ? <Loader /> : null}
      <Modal.Body>
        <ModalHeader HeaderName={dgheading} DeletePopup={""} isClosed={onCloseCPT} key={''} Name={'ProcedureSearch'} />
        <div className='br-clr mt-2'>
          <div className="row">
            <div className="m-0 align-items-center mb-2 row pe-0">
              <div className="col-md-8 px-0 popup_super_search">
                <div className="input col-12 pe-0">
                  <div className='input-group hk-input-search'>
                    <input type="text" className='form-control fc-xs'
                      placeholder='Search Procedure codes by code or description….'
                      onChange={e => setSearchParam(e.target.value)}
                      onKeyDown={SearchOnEnter}
                    />
                    <span className="input-group-text seraches" id="basic-addon2" onClick={() => LoadData(searchParam)}>
                      <i className="bi bi-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              {options === false ? null :
                <div className="col-md-4">
                  <div class="input">
                    <select class="form-control rounded fc-xs" id="ProviderID" name="ProviderID" onChange={handleOnChange}>
                      <option value="CPT">Procedure Code</option>
                      <option value="ProcedureMacro">Procedure Macros</option>
                    </select>
                  </div>
                </div>
              }
              {/* <div className="master_head col-2 pe-0">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">
                                    <i className="icon-table-view" /> Show All
                                </button>
                            </div> */}
            </div>
            {/* <div className="col-12">
              <div className="form-check d-flex align-items-center gap-1">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="active"
                  value={active}
                  onChange={() => setActive(!active)}
                />
                <label className="form-check-label" for="active">Include Inactive codes</label>
              </div>
            </div> */}
            <div className="col-12">
              <div className="opened-block ar-grid-border">
                <p className="heading">{recOpened ? 'Recently Opened' : 'Recently Searched'}</p>
                {searchMethod === 'CPT' ?
                  <DataGrid
                    columns={columnsAll}
                    rows={recCPT}
                    selectedRows={selectedRows}
                    onSelectedRowsChange={onRowSelection}
                    rowKeyGetter={rowKeyGetter}
                    defaultColumnOptions={{ resizable: true }}
                    className="all_audit service_line_grid custom_checkboxes_gird_two fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                  /> : <DataGrid
                    columns={columnsAllMacro}
                    rows={recProMacro}
                    selectedRows={selectedRows}
                    onSelectedRowsChange={onRowSelection}
                    rowKeyGetter={rowKeyGetterMacro}
                    defaultColumnOptions={{ resizable: true }}
                    className="all_audit service_line_grid custom_checkboxes_gird_two fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                  />}

                {/* <Pagination
                                    PerPage={PerPage}
                                    PageNo={PageNo}
                                    TotalPages={TotalPages}
                                    handlePageClick={handlePageClick}
                                    PreviousPage={PreviousPage}
                                    handleFingByCreteria={handleFingByCreteria}
                                    NextPage={NextPage}
                                /> */}
              </div>
            </div>
            {/* <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
              <button className="btn btn-gray" onClick={onCloseCPT}>Cancel</button>
              <button className="btn btn-orange" onClick={onSelectCPT}>Select</button>
            </div> */}
          </div>
        </div>
      </Modal.Body>
      <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
        <button className='btn btn-outline px-10 h-100' onClick={onCloseCPT}>Cancel</button>
        <button className='btn btn-validate px-10 h-100' onClick={onSelectCPT}>Select</button>
      </div>
    </Modal>
  )
}

export default ProcedureSearch